import { useEffect, useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
  initialValue?: string;
  size?: 'md' | 'lg';
  placeholder?: string;
  autoFocus?: boolean;
  onSubmitted?: () => void;
}

export default function SearchBar({
  initialValue = '',
  size = 'md',
  placeholder = '搜索电影、电视剧名称',
  autoFocus = false,
  onSubmitted,
}: SearchBarProps) {
  const [value, setValue] = useState(initialValue);
  const navigate = useNavigate();

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const kw = value.trim();
    if (!kw) return;
    navigate(`/search?q=${encodeURIComponent(kw)}`);
    onSubmitted?.();
  };

  const isLg = size === 'lg';

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div
        className={`flex items-center gap-2 rounded-full border border-background-700 bg-background-900/80 px-2 transition-colors focus-within:border-primary-500 ${
          isLg ? 'h-14 pl-5 pr-2' : 'h-11 pl-4 pr-1.5'
        }`}
      >
        <i className={`ri-search-line text-foreground-400 ${isLg ? 'text-xl' : 'text-base'}`} />
        <input
          type="text"
          value={value}
          autoFocus={autoFocus}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          className={`flex-1 bg-transparent text-foreground-100 placeholder:text-foreground-500 outline-none ${
            isLg ? 'text-base' : 'text-sm'
          }`}
        />
        <button
          type="submit"
          className={`flex shrink-0 items-center justify-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 font-medium text-background-950 transition-colors hover:bg-primary-400 ${
            isLg ? 'h-11 px-6 text-base' : 'h-8 px-4 text-sm'
          }`}
        >
          <i className="ri-search-line" />
          <span className="hidden sm:inline">搜索</span>
        </button>
      </div>
    </form>
  );
}